import { Stack } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { CopyInput, CopyQRCode, QRCodeWrapper } from '@woovi/ui';

import type { PaymentPixAutomaticQRCode_subscription$key } from './__generated__/PaymentPixAutomaticQRCode_subscription.graphql';
import PaymentPixAutomaticLinkShareButton from './PaymentPixAutomaticLinkShareButton.tsx';
import PaymentLinkActiveOpenBankInfo from '../active/paymentLinkActive/PaymentLinkActiveOpenBankInfo.tsx';

type PaymentPixAutomaticProps = {
  pixAutomatic: PaymentPixAutomaticQRCode_subscription$key;
};

const PaymentPixAutomaticQRCode = (
  props: PaymentPixAutomaticProps,
): ReactNode => {
  const pixAutomatic = useFragment<PaymentPixAutomaticQRCode_subscription$key>(
    graphql`
      fragment PaymentPixAutomaticQRCode_subscription on PaymentSubscription {
        pixRecurring {
          emv
        }
        ...PaymentPixAutomaticLinkShareButton_subscription
      }
    `,
    props.pixAutomatic,
  );

  const emv = pixAutomatic.pixRecurring?.emv as string;

  return (
    <Stack sx={{ width: '100%', alignItems: 'center', gap: 1 }}>
      <Stack
        sx={{
          width: '100%',
          maxWidth: (theme) => theme.sizing.maxPixWidth,
          gap: 1,
        }}
      >
        <QRCodeWrapper qrCodeShow data-testid='qrcode'>
          <QRCodeSVG value={emv} marginSize={4} />
        </QRCodeWrapper>
        <Stack
          sx={{
            '@media (min-width: 600px)': {
              display: 'none',
            },
          }}
        >
          <CopyInput value={emv} />
        </Stack>
        <PaymentLinkActiveOpenBankInfo />
        <CopyQRCode value={emv} />
        <PaymentPixAutomaticLinkShareButton pixAutomatic={pixAutomatic} />
      </Stack>
    </Stack>
  );
};

export default PaymentPixAutomaticQRCode;
